import Swagger from "swagger-client"
import userInfoProvider from "./userInfoProvider"
import parseUrl from "parse-url"
import router from '@/router'
import {getItem} from "@/services/cookies.service";

const swaggerClients = {}

export default class {
  public options: any;
  private client: any;
  private operations = {};

  constructor(options: any) {
    this.options = options
  }

  public async execute(operationId: string, parameters: any = {}, defaultParameters: any = {}, handleErrors: any = null) {
    await this.initializeIfNeed()
    parameters = this.makeParameters(parameters, defaultParameters)
    try {
      return await this.client.execute({
        operationId,
        parameters,
        scheme: this.options.scheme,
      })
    } catch (err) {
      if (handleErrors && typeof handleErrors === 'function') {
        return handleErrors(err)
      }
      if (err && err.response && err.response.status === 401 && !handleErrors) {
        userInfoProvider.deleteAccessToken()
        window.location.href = '/user/login'
      }
      let errorMessage = err
      if (err.response && err.response.body) {
        errorMessage = err.response.body.message;
      }
      throw new Error(errorMessage)
    }
  }

  private async initializeIfNeed() {
    if (this.client) {
      return
    }
    if (swaggerClients[this.options.url]) {
      this.client = swaggerClients[this.options.url]
    } else {
      this.client = await Swagger({
        url: this.options.url,
        requestInterceptor: request => {
          let params: any = {};
          if (request.method === 'GET') {
            params = this.getParamsInUrl(request.url);
          } else {
            params = !!request.body ? this.getBodyInRequest(request.body) : {};
          }
          const token = (params.ctx && params.ctx.access_token) || userInfoProvider.getAccessToken();
          if (token) {
            request.headers.Authorization = `Bearer ${token}`;
          }
          return request;
        },
      })
      swaggerClients[this.options.url.toString()] = this.client
    }
    const url = parseUrl(this.options.url)
    if (!this.options.scheme) {
      this.options.scheme = url.protocol
    }
    let scheme = url.protocol
    let host;
    if (url.resource) {
      host = url.resource + ":" + url.port
    } else {
      host = location.host
      scheme = location.protocol ? location.protocol.substr(0, location.protocol.length - 1) : ""
    }
    for (const path in this.client.spec.paths) {
      const pathSpec = this.client.spec.paths[path]
      for (const method in pathSpec) {
        const methodInfo = pathSpec[method]
        this.operations[methodInfo.operationId] = {scheme, host, path, method}
      }
    }
  }

  private makeParameters(parameters: any = {}, defaultParameters: any = {}) {
    let accessToken;
    if (defaultParameters["ctx.domain_id"] !== undefined) {
      parameters["ctx.domain_id"] = defaultParameters["ctx.domain_id"]
    } else {
      parameters["ctx.domain_id"] = userInfoProvider.getDomainId()
    }
    if (parameters.body
        && parameters.body.ctx
        && parameters.body.ctx.access_token
        && parameters.body.ctx.access_token !== "") {
      accessToken = parameters.body.ctx.access_token;
    } else {
      accessToken = userInfoProvider.getAccessToken();
    }
    if ((!accessToken || accessToken === "") && !router.currentRoute.path.startsWith("/login")) {
      router.push("/login")
    }
    if (parameters.body) {
      parameters.body.ctx = {
        ...parameters.body.ctx,
        access_token: accessToken
      }
    } else {
      parameters["ctx.access_token"] = accessToken
    }
    if (!parameters["ctx.user_id"]) {
      parameters["ctx.user_id"] = userInfoProvider.getUserId()
    }
    return parameters
  }

  private getParamsInUrl(url: string) {
    if (url) {
      const queryParams = url.split('?')[1] || '';
      const params = queryParams.split('&');

      let pair = null;
      const data = {};
      params.forEach((d) => {
        pair = d.split('=');
        data[pair[0]] = pair[1];
      });
      return data;
    }
    return {};
  }

  private getBodyInRequest(bodyString: string) {
    try {
      return JSON.parse(bodyString);
    } catch (e) {
      return bodyString;
    }
  }
}
